/* Lagon V4 — magie : éclats de bulles, apparitions, livraison estimée */
(() => {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Éclat : pluie de paillettes + petits animaux des gourdes ---------- */
  const glitter = ['#FFD84D', '#FFF3B0', '#FF7EB3', '#FFC1DC', '#8FE3FF', '#C9B6FF', '#FFFFFF', '#7CF0C8'];
  const critters = ['🐳', '🐋', '🐻', '🐮', '🦕', '🦄', '🐰', '🐥', '🐙', '🐬'];
  const fly = (el, x, y, dx, dy, size, dur, spin) => {
    el.animate([
      { transform: `translate(${x - size / 2}px, ${y - size / 2}px) scale(.2) rotate(0deg)`, opacity: 1 },
      { transform: `translate(${x + dx * .7 - size / 2}px, ${y + dy * .7 - size / 2}px) scale(1) rotate(${spin * .6}deg)`, opacity: 1, offset: .45 },
      { transform: `translate(${x + dx - size / 2}px, ${y + dy + 60 - size / 2}px) scale(.7) rotate(${spin}deg)`, opacity: 0 }
    ], { duration: dur, easing: 'cubic-bezier(.15,.8,.3,1)' }).onfinish = () => el.remove();
  };
  const burst = (x, y, sparkles = 40, animals = 3, spread = 120) => {
    if (reduce || !document.body.animate) return;
    for (let i = 0; i < sparkles; i++) {
      const el = document.createElement('span');
      const star = i % 5 === 0;
      const size = star ? 8 + Math.random() * 8 : 3 + Math.random() * 6;
      el.className = 'fx ' + (star ? 'fx--star' : 'fx--glitter');
      const c = glitter[(Math.random() * glitter.length) | 0];
      el.style.width = el.style.height = size + 'px';
      el.style.background = star ? c : `linear-gradient(135deg, #fff, ${c})`;
      el.style.boxShadow = `0 0 6px ${c}`;
      document.body.appendChild(el);
      const a = Math.random() * Math.PI * 2, d = spread * (.3 + Math.random() * .9);
      fly(el, x, y, Math.cos(a) * d, Math.sin(a) * d - 50, size, 900 + Math.random() * 900, (Math.random() * 720) - 360);
    }
    for (let k = 0; k < animals; k++) {
      const el = document.createElement('span');
      const fs = 20 + Math.random() * 14;
      el.className = 'fx fx--critter';
      el.textContent = critters[(Math.random() * critters.length) | 0];
      el.style.setProperty('--fs', fs + 'px');
      document.body.appendChild(el);
      const a = -Math.PI / 2 + (Math.random() - .5) * 2.2, d = spread * (.7 + Math.random() * .6);
      fly(el, x, y, Math.cos(a) * d, Math.sin(a) * d - 30, fs, 1500 + Math.random() * 700, (Math.random() * 60) - 30);
    }
  };
  window.LagonBurst = burst;

  /* ---------- Fontaine de paillettes : un jet doré et multicolore qui jaillit vers le haut puis retombe en scintillant ---------- */
  const gold = ['#FFD700', '#FFC93C', '#FFE680', '#FFF3B0', '#FFB800', '#FFFFFF'];
  const rainbow = ['#FF7EB3', '#8FE3FF', '#C9B6FF', '#7CF0C8', '#FF9A3C', '#FF5FA8'];
  const fountain = (x, y, count = 120, animals = 3) => {
    if (reduce || !document.body.animate) return;
    for (let i = 0; i < count; i++) {
      const el = document.createElement('span');
      const kind = i % 6; // 0 = étoile, 1 = losange, sinon paillette ronde
      const c = Math.random() < .6 ? gold[(Math.random() * gold.length) | 0] : rainbow[(Math.random() * rainbow.length) | 0];
      const size = kind === 0 ? 9 + Math.random() * 10 : kind === 1 ? 6 + Math.random() * 6 : 3 + Math.random() * 5;
      el.className = 'fx ' + (kind === 0 ? 'fx--star' : 'fx--glitter');
      el.style.width = el.style.height = size + 'px';
      el.style.background = kind === 0 ? c : `linear-gradient(135deg, #fff 0%, ${c} 45%, ${c} 100%)`;
      el.style.boxShadow = `0 0 ${6 + size}px ${c}`;
      document.body.appendChild(el);
      const ang = -Math.PI / 2 + (Math.random() - .5) * 1.5;
      const v = 7 + Math.random() * 10;
      const vx = Math.cos(ang) * v, vy = Math.sin(ang) * v, g = .42;
      const T = 34 + Math.random() * 24, steps = 10, frames = [];
      for (let s = 0; s <= steps; s++) {
        const t = T * s / steps;
        const px = x + vx * t - size / 2 + Math.sin(t / 4 + i) * 6;
        const py = y + vy * t + g * t * t / 2 - size / 2;
        frames.push({
          transform: `translate(${px}px, ${py}px) rotate(${(kind === 1 ? 45 : 0) + t * 12}deg) scale(${s === 0 ? .3 : 1 - (s / steps) * .45})`,
          opacity: s === steps ? 0 : (s % 2 ? .5 : 1)
        });
      }
      el.animate(frames, { duration: 1400 + Math.random() * 1000, easing: 'linear' }).onfinish = () => el.remove();
    }
    burst(x, y, 0, animals, 150);
  };
  window.LagonFountain = fountain;

  // Toucher une bulle de savon : elle éclate en paillettes et en petits animaux, puis revient au cycle suivant
  document.addEventListener('pointerdown', (e) => {
    const b = e.target.closest('.mb');
    if (!b || b.classList.contains('is-popped')) return;
    const r = b.getBoundingClientRect();
    b.classList.add('is-popped');
    burst(r.left + r.width / 2, r.top + r.height / 2, 46, 3, 130);
    b.addEventListener('animationiteration', () => b.classList.remove('is-popped'), { once: true });
  });

  // Ajout au panier : feu d'artifice de paillettes et d'animaux depuis le bouton
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    const btn = e.submitter || form.querySelector('[type="submit"]');
    if (!btn) return;
    const r = btn.getBoundingClientRect();
    burst(r.left + r.width / 2, r.top + r.height / 2, 50, 4, 150);
  }, true);

  // Toucher le fond des zones magiques fait aussi pleuvoir quelques paillettes
  $$('[data-magic-zone]').forEach((zone) => {
    zone.addEventListener('pointerdown', (e) => {
      if (e.target.closest('a, button, input, label, select, .mb, [data-lumi]')) return;
      burst(e.clientX, e.clientY, 22, 1, 90);
    });
  });

  /* ---------- Apparition douce au défilement ---------- */
  if (!reduce && 'IntersectionObserver' in window) {
    const targets = '.section__title, .section__sub, .chip, .grid__item, .bubbles__item, .trust__item, .spot__card, .review, .faq__item, .newsletter__card, .iwt__media, .iwt__copy, .post-card, .mascot__bubble';
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    $$(targets).forEach((el) => {
      if (el.closest('.hero, .drawer, .qv-dialog')) return;
      const sibs = el.parentElement ? Array.from(el.parentElement.children) : [];
      el.style.setProperty('--rv', Math.min(sibs.indexOf(el), 8));
      el.classList.add('rv');
      io.observe(el);
    });
  }

  /* ---------- Livraison estimée : jours OUVRABLES (week-ends exclus), dates en français ---------- */
  $$('[data-eta]').forEach((box) => {
    const min = +box.dataset.min || 8, max = +box.dataset.max || 18;
    const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
    const addWorkdays = (n) => {
      const t = new Date();
      while (n > 0) { t.setDate(t.getDate() + 1); const wd = t.getDay(); if (wd !== 0 && wd !== 6) n--; }
      return fmt.format(t);
    };
    const out = box.querySelector('[data-eta-range]');
    if (out) out.textContent = `Commandé aujourd'hui, chez vous entre le ${addWorkdays(min)} et le ${addWorkdays(max)}`;
  });

  /* ---------- Lumira vivante : elle danse, dit coucou et répond quand on la touche ---------- */
  $$('[data-lumi]').forEach((lumi) => {
    const sec = lumi.closest('.mascot') || document;
    const say = sec.querySelector('[data-lumi-say]');
    let lines = [];
    try { lines = JSON.parse(sec.querySelector('[data-lumi-lines]').textContent).map((l) => l.trim()).filter(Boolean); } catch (e) { lines = []; }
    if (!lines.length) lines = ['Coucou ! 👋'];
    let idx = 0, typing, timer;
    const type = (txt) => {
      if (!say) return;
      clearInterval(typing);
      if (reduce) { say.textContent = txt; return; }
      const chars = Array.from(txt); let i = 0; say.textContent = '';
      typing = setInterval(() => { say.textContent += chars[i++] || ''; if (i >= chars.length) clearInterval(typing); }, 35);
    };
    const happy = () => { lumi.classList.remove('is-happy'); void lumi.offsetWidth; lumi.classList.add('is-happy'); };
    lumi.addEventListener('animationend', (e) => { if (e.animationName === 'lumi-jump') lumi.classList.remove('is-happy'); });
    let surprised = false;
    try { surprised = sessionStorage.getItem('lumiSurprise') === 'shown'; } catch (e) { /* stockage indisponible */ }
    const revealSurprise = (x, y) => {
      happy();
      lumi.classList.add('is-surprise');
      setTimeout(() => lumi.classList.remove('is-surprise'), 5000);
      type("🎉 Tu m'as trouvée ! Cadeau débloqué : -10% avec le code WELCOME10 ✨");
      fountain(x, y, 220, 6);
      surprised = true;
      try { sessionStorage.setItem('lumiSurprise', 'shown'); } catch (e) { /* ignore */ }
    };
    const react = (x, y) => {
      if (!surprised) { revealSurprise(x, y); return; }
      happy();
      idx = (idx + 1) % lines.length; type(lines[idx]);
      fountain(x, y, 130, 3);
    };
    lumi.addEventListener('click', (e) => react(e.clientX, e.clientY));
    lumi.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      const r = lumi.getBoundingClientRect(); react(r.left + r.width / 2, r.top + r.height / 3);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        clearInterval(timer);
        if (!en.isIntersecting) return;
        type(lines[idx]); happy();
        timer = setInterval(() => { idx = (idx + 1) % lines.length; type(lines[idx]); }, 6000);
      }, { threshold: .4 }).observe(lumi);
    } else { type(lines[0]); }
  });
})();
